'use client';

import { useRef } from 'react';

import { INDUSTRIAL_PAGE_HEADING } from '@/data/shared/industrialCopy';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import SolutionMachine from '@/components/apps/pages/solution/industrial/SolutionMachine';
import { INDUSTRIAL_SOLUTION_ID } from '@/components/apps/pages/solution/industrial/industrialAnalytics';
import { useSolutionLandingAnalytics } from '@/components/apps/pages/solution/shared/useSolutionLandingAnalytics';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

export default function IndustrialPageClient({ lng }: { lng: string }) {
  const heading =
    lng === 'ko' ? INDUSTRIAL_PAGE_HEADING.ko : INDUSTRIAL_PAGE_HEADING.en;
  const pageRef = useRef<HTMLDivElement | null>(null);
  useSolutionLandingAnalytics(pageRef, {
    solutionId: INDUSTRIAL_SOLUTION_ID,
    language: lng,
  });

  return (
    <div ref={pageRef}>
      <VisuallyHiddenPageTitle>{heading}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <SolutionMachine />
      </ResponsiveLayout>
    </div>
  );
}
